import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWebAiChatMessagesQueryVariables = Types.Exact<{
  doctrine_chat_id: Types.Scalars['String']['input'];
}>;


export type GetWebAiChatMessagesQuery = { __typename?: 'query_root', get_web_aichat_messages?: Array<{ __typename?: 'webAiChatMessageOutput', id: string, message: string, isSystem: boolean, createdAt: string, userId?: string | null, chatId: string, thoughts?: string | null, user?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, profile_photo?: string | null, role?: string | null } | null, multimodal_attachments?: Array<{ __typename?: 'ChatMessageAttachment', id: string, fileName: string, mimeType: string, publicUrl?: string | null, fileType: string, fileKey?: string | null, gsUri?: string | null } | null> | null, citations?: { __typename?: 'CitationMetadata', chunks: Array<{ __typename?: 'CitationChunk', uri: string, title: string }>, supports: Array<{ __typename?: 'CitationSupport', groundingChunkIndices: Array<number>, segment: { __typename?: 'CitationSegment', text: string, startIndex: number, endIndex: number } }> } | null, aiChat?: { __typename?: 'ai_chats', id: any, doctrine_chat_id: string, workspace_id?: any | null, partition_id?: string | null, partitions_ids?: Array<string> | null, organization_id?: any | null, created_at: any, doctrine_title?: string | null, is_brief: boolean, brief_frequency?: string | null, chat_origin: string, ai_chat_user_selections: Array<{ __typename?: 'ai_chat_user_selections', id: any, guide_id?: any | null, property_id?: any | null, product_id?: any | null, installed_product_id?: any | null, shop_product_id?: any | null, property?: { __typename?: 'properties', id: any, name: string } | null, product?: { __typename?: 'products', id: any, name: string } | null, installed_product?: { __typename?: 'installed_products', id: any, product_id: any, property_id: any, product: { __typename?: 'products', id: any, name: string }, property?: { __typename?: 'properties', id: any, name: string } | null } | null, shop_product?: { __typename?: 'shop_products', id: any, product_id: any, property_id: any, product?: { __typename?: 'products', id: any, name: string } | null, property?: { __typename?: 'properties', id: any, name: string } | null } | null }> } | null, aiChatSources: Array<{ __typename?: 'ai_chat_sources', id: any, attachment_name: string, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, property?: { __typename?: 'properties', id: any, name: string } | null, product?: { __typename?: 'products', id: any, name: string } | null, installed_product?: { __typename?: 'installed_products', id: any } | null }> } | null> | null };


export const GetWebAiChatMessagesDocument = gql`
    query getWebAiChatMessages($doctrine_chat_id: String!) {
  get_web_aichat_messages(doctrine_chat_id: $doctrine_chat_id) {
    id
    message
    isSystem
    createdAt
    userId
    user {
      id
      first_name
      last_name
      email
      profile_photo
      role
    }
    chatId
    multimodal_attachments {
      id
      fileName
      mimeType
      publicUrl
      fileType
      fileKey
      gsUri
    }
    thoughts
    citations {
      chunks {
        uri
        title
      }
      supports {
        segment {
          text
          startIndex
          endIndex
        }
        groundingChunkIndices
      }
    }
    aiChat {
      id
      doctrine_chat_id
      workspace_id
      partition_id
      partitions_ids
      organization_id
      created_at
      doctrine_title
      is_brief
      brief_frequency
      chat_origin
      ai_chat_user_selections {
        id
        guide_id
        property_id
        property {
          id
          name
        }
        product_id
        product {
          id
          name
        }
        installed_product_id
        installed_product {
          id
          product_id
          product {
            id
            name
          }
          property_id
          property {
            id
            name
          }
        }
        shop_product_id
        shop_product {
          id
          product_id
          product {
            id
            name
          }
          property_id
          property {
            id
            name
          }
        }
      }
    }
    aiChatSources {
      id
      attachment_name
      photo_link
      document_link
      video_link
      audio_link
      site_link
      property {
        id
        name
      }
      product {
        id
        name
      }
      installed_product {
        id
      }
    }
  }
}
    `;

/**
 * __useGetWebAiChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetWebAiChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebAiChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebAiChatMessagesQuery({
 *   variables: {
 *      doctrine_chat_id: // value for 'doctrine_chat_id'
 *   },
 * });
 */
export function useGetWebAiChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables> & ({ variables: GetWebAiChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>(GetWebAiChatMessagesDocument, options);
      }
export function useGetWebAiChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>(GetWebAiChatMessagesDocument, options);
        }
export function useGetWebAiChatMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>(GetWebAiChatMessagesDocument, options);
        }
export type GetWebAiChatMessagesQueryHookResult = ReturnType<typeof useGetWebAiChatMessagesQuery>;
export type GetWebAiChatMessagesLazyQueryHookResult = ReturnType<typeof useGetWebAiChatMessagesLazyQuery>;
export type GetWebAiChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetWebAiChatMessagesSuspenseQuery>;
export type GetWebAiChatMessagesQueryResult = Apollo.QueryResult<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>;